import Components from "../components";

class Pusher extends Components.Base {
  initialize() {
    this.config = $.parseJSON(this.$el.attr("content"));

    if (this.config.user) {
      this.loadPusher();
    }
  }

  loadPusher() {
    if (window.pusherLoaded) {
      return;
    }

    window.pusherLoaded = true;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.onload = () => {
      window.initPusher(
        new window.Pusher(this.config.key, {
          encrypted: true,
          cluster: this.config.cluster,
        }),
        this.config.user.id,
      );
    };
    script.src = "https://d3dy5gmtp8yhk7.cloudfront.net/2.2/pusher.min.js";
    // Turbo fires the first turbo:load from readystatechange, as readyState
    // becomes "complete". WebKit never fires window's load event if a script
    // is added at that point, and Bootstrap sets up its tabs on load. The
    // readyState change and load run in the same task, so a zero-delay
    // timeout adds the script after load.
    setTimeout(() => document.head.appendChild(script));
  }
}

Components.collection.register({
  selector: "meta[name=i-pusher]",
  klass: Pusher,
});
